export const minimumNaturalNumber = 0;
export const maximumQuantity = 999;

export const maximumOdometer = 10000000; // === 10,000,000.0

export const minimumAmount = 0.0;
export const maximumAmountWithoutVat = 999000000.0; // === 999,000,000.0

export const maximumCommentLength = 255;

export const minimumAge = 18;
export const maximumAge = 69;

export const minPercent = 0.0;
export const maxPercent = 100.0;

export const minimumChAmount = 0.0;
export const maximumChAmount = 9007199254740991.0;

export const maximumInteger = 2147483647;

export const addressFieldMaxLength = {
  street: 255,
  number: 50,
  building: 25,
  stair: 50,
  flatNumber: 25,
  floor: 50,
  zipCode: 20,
  neighborhood: 100
};
